import { render, staticRenderFns } from "./ThePriceCompetitorFilters.vue?vue&type=template&id=44dc3574&scoped=true&"
import script from "./ThePriceCompetitorFilters.vue?vue&type=script&lang=js&"
export * from "./ThePriceCompetitorFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dc3574",
  null
  
)

export default component.exports